import * as React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import { PageNotFound } from '../../youwell-common/components';
import urls from '../../app/urls';
import User from './User';
import UserList from './UserList';
import NewUser from './NewUser';
import LoadUsers from './components/LoadUsers';
import { TopActionBar } from '../../common/components';

const styles = theme => ({
    root: {

    },
    content: {
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(8),

        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
        },
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            padding: theme.spacing(1),
        },
    },
});


class Index extends React.Component {
    render() {
        const {
            classes, translate, location,
        } = this.props;

        return (
            <div className={classes.root}>
                <TopActionBar
                    title={translate('user.userAdmin')}
                    backLink={location.pathname === urls.inside.users.home ? null : {
                        to: `${urls.inside.users.home}`,
                        text: translate('user.backToOverview'),
                    }}
                    linkAction={location.pathname === urls.inside.users.home ? `${urls.inside.users.new}` : null}
                    linkActionText={location.pathname === urls.inside.users.home ? translate('user.newUser') : null}
                />

                <LoadUsers />

                <div className={classes.content}>
                    <Switch>
                        <Route exact path={urls.inside.users.home} component={UserList} />
                        <Route exact path={urls.inside.users.new} component={NewUser} />
                        <Route path={`${urls.inside.users.home}/:id`} component={User} />
                        <Route component={PageNotFound} />
                    </Switch>
                </div>
            </div>
        );
    }
}


Index.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(Index));
